import { render, staticRenderFns } from "./PerformanceEnergy.vue?vue&type=template&id=414877d4&"
import script from "./PerformanceEnergy.vue?vue&type=script&lang=js&"
export * from "./PerformanceEnergy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports